import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBar from '@/components/feature/MobileBar';

export default function Horarios() {
  const { t } = useTranslation();

  const title = t('seo.horarios.title');
  const description = t('seo.horarios.description');
  const keywords = t('seo.horarios.keywords');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://topgym.com.br';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: `${siteUrl}/horarios`,
    mainEntity: {
      '@type': 'GymOrSportsActivityLocation',
      name: 'Top Gym Cumbuco',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '06:00',
          closes: '22:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '08:00',
          closes: '12:00',
        },
      ],
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: t('nav.home'),
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: t('page.horarios.title'),
        item: `${siteUrl}/horarios`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO title={title} description={description} keywords={keywords} path="/horarios" schema={[schema, breadcrumbSchema]} />
      <Navbar />
      <main className="overflow-x-hidden pb-20 md:pb-0">
        <section className="bg-foreground-950 py-20 md:py-28">
          <div className="w-full px-4 md:px-6">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50">
              {t('page.horarios.title')}
            </h1>
            <p className="font-body text-base text-background-300 mt-4 max-w-xl">
              {t('page.horarios.subtitle')}
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-foreground-950 rounded-lg p-6 md:p-8 text-center">
                <p className="font-heading text-2xl md:text-3xl text-primary-500">{t('page.horarios.weekday')}</p>
                <p className="font-heading text-4xl md:text-5xl text-background-50 mt-2">{t('page.horarios.weekdayHours')}</p>
              </div>
              <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8 text-center">
                <p className="font-heading text-2xl md:text-3xl text-foreground-500">{t('page.horarios.saturday')}</p>
                <p className="font-heading text-4xl md:text-5xl text-foreground-950 mt-2">{t('page.horarios.saturdayHours')}</p>
              </div>
              <div className="bg-foreground-950 rounded-lg p-6 md:p-8 text-center">
                <p className="font-heading text-2xl md:text-3xl text-secondary-500">{t('page.horarios.sunday')}</p>
                <p className="font-heading text-4xl md:text-5xl text-background-50 mt-2">{t('page.horarios.sundayHours')}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}